import { StyleSheet } from 'react-native';

import { Colors } from '../Themes';

const sectionContainerStyle = {
  borderLeftWidth: 1,
  borderColor: Colors.veryLightPink,
  paddingBottom: 40,
  marginLeft: 22,
  paddingHorizontal: 10,
};

export default StyleSheet.create({
  scrollViewContainer: {
    flex: 1,
  },
  accordionStyle: {
    paddingBottom: 10,
  },
  activeSectionContainerStyle: theme => ({
    ...sectionContainerStyle,
    borderColor: theme.colors.secondryColor,
    paddingBottom: 0,
  }),
  completedSectionContainerStyle: theme => ({
    ...sectionContainerStyle,
    borderColor: theme.colors.secondryColor,
  }),
  newOrSkippedSectionContainerStyle: theme => ({
    ...sectionContainerStyle,
    borderColor: theme.colors.inactiveSeparator,
  }),
  finalSectionContainerStyle: {
    ...sectionContainerStyle,
    borderColor: Colors.transparent,
    paddingBottom: 0,
  },
});
